export default {
  files: [],
  cancelToken: null,
}
